import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ChipCheckerResults, PetService } from 'src/app/services/pet/pet.service';

@Component({
  selector: 'app-chip-checker-v2',
  templateUrl: './chip-checker-v2.component.html',
  styleUrls: ['./chip-checker-v2.component.scss'],
})
export class ChipCheckerV2Component implements OnInit {
  chipCheckerLoading = false;
  chipCheckerResults: ChipCheckerResults = null;
  chipCheckerNumber: string;
  isBrowser: boolean;

  constructor(
    private petService: PetService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {}

  trackEvent(event: string): void {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  checkChip(): void {
    this.trackEvent('homepage::checkachip::clicked');
    this.chipCheckerLoading = true;
    this.chipCheckerResults = null;
    this.petService
      .checkChip(this.chipCheckerNumber)
      .subscribe((results) => {
        this.chipCheckerResults = results;
      })
      .add(() => {
        this.chipCheckerLoading = false;
      });
  }
}
